import React, { useState } from 'react';
import Dialog, { DialogContent, DialogTitle } from 'react-scale/components/design-system/Dialog';
import { makeStyles } from 'design-system/styles';
import TaskComponent from 'react-scale/components/Task/TaskComponent';
import { Button } from 'design-system';

import { TaskType } from '@scale/shared-types';

interface TaskViewProps {
  taskProps: any;
  taskType: TaskType;
  nextButtonIsDisabled: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
  previousButtonIsDisabled: boolean;
  onClose: any;
  title: string;
}

const TaskView = ({
  taskProps,
  taskType,
  nextButtonIsDisabled,
  onClickNext,
  onClickPrevious,
  previousButtonIsDisabled,
  onClose,
  title,
}: TaskViewProps) => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState<any>(true);

  const onCloseModal = () => {
    setIsModalOpen(false);
    onClose();
  };

  return (
    <div>
      <Dialog
        open={isModalOpen}
        onClose={onCloseModal}
        maxWidth="xl"
        fullWidth={true}
        style={{ zIndex: 10000 }}
      >
        <DialogTitle>
          <div className={classes.titleContainer}>
            <div>
              <Button className={classes.leftButton} onClick={onCloseModal} type="secondary">
                Exit
              </Button>
              <Button onClick={onClickPrevious} type="primary" disabled={previousButtonIsDisabled}>
                Previous
              </Button>
            </div>
            {title}
            <div>
              {nextButtonIsDisabled ? (
                <Button onClick={onCloseModal} type="primary">
                  Finish
                </Button>
              ) : (
                <Button onClick={onClickNext} type="primary">
                  Next
                </Button>
              )}
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div key={taskProps.id} className={classes.taskpreview}>
            <TaskComponent taskType={taskType} taskProps={taskProps} compact={true} />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  container: {},
  taskpreview: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '70vh',
    overflow: 'auto',
    height: '95vh',
    justifyContent: 'center',
  },
  textfield: {
    margin: '18px',
    width: '150%',
  },
  leftButton: {
    marginRight: '8px',
  },
  button: {
    width: 100,
    margin: 5,
  },
}));
export default TaskView;
